import axios from "axios";

const authService =
{    
    login: async (email: string, password: string, metadata: string | undefined): Promise<any> =>
    {
        try {
            const response = await axios.post(process.env.REACT_APP_API_URL + '/api/Account/login', {
                email,
                password,
                metadata
            });

            return response.data;

        } catch (error: any) {
            throw error.response ? error.response.data : error.message;
        }   
    },
    refreshToken: async (token: string, refreshToken: string): Promise<any> => {
        try {
            const response = await axios.post(process.env.REACT_APP_API_URL + '/api/Account/refresh', {
                token,
                refreshToken
            });

            return response.data;

        } catch (error: any) {
            throw error.response ? error.response.data : error.message;
        }
    },
    validateAfiliado: async (data: any): Promise<any> => {
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL + "/api/Account/validateAfiliado",
                data
            );

            return response.data;
        } catch (error: any) {
            throw error.response ? error.response.data : error.message;
        }
    },
    signup: async (data: any): Promise<any> => {
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL + "/api/Account/signup",
                data
            );

            return response.data;
        } catch (error: any) {
            throw error.response ? error.response.data : error.message;
        }
    },
    verifiedAccount: async (email: string): Promise<any> => {
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL + "/api/Account/verifiedAccount",
                { email }
            );

            return response.data;
        } catch (error: any) {
            throw error.response ? error.response.data : error.message;
        }
    },
    resendVerificationEmail: async (data: any): Promise<any> => {
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL + "/api/Account/resendVerificationEmail",
                data
            );

            return response.data;
        } catch (error: any) {
            throw error.response ? error.response.data : error.message;
        }
    },
    forgotPassword: async (data: any): Promise<any> => {
        try {
            let url = `${process.env.REACT_APP_API_URL}/api/Account/forgotPassword/${data}`;
            const response = await axios.post(
                url,
                {}
            );
            return response.data;
        } catch (error: any) {
            throw error.response ? error.response.data : error.message;
        }
    },
    uploadImage: async (afiId: string, file: File): Promise<any> => {
        try {
            const formData = new FormData();

            formData.append("afi_id", afiId);
            formData.append("FileType", file.type);
            formData.append("File", file);   

            const response = await axios.post(
                process.env.REACT_APP_API_URL + "/api/Account/uploadImage",
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            return response.data;
        } catch (error: any) {
            throw error.response ? error.response.data : error.message;
        }
    },
};

export default authService
